export * as flags from './flags';
export * from './flags';
export * as icos from './icos';
export * from './icos';
export * from './types';
